import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { StyleClassModule } from 'primeng/styleclass';

@Component({
  standalone: true,
  selector: 'app-footer',
  imports: [CommonModule, FormsModule, InputTextModule, StyleClassModule],
  template: `
    <footer>
      <div class="bg-surface-0 dark:bg-surface-950 px-6 md:px-12 lg:px-20">
        <div class="py-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div class="flex flex-col gap-4">
            <div class="flex items-center gap-4">
              <img src="assets/images/logo_only.png" class="max-h-11" alt="Image" />
              <span class="text-xl text-primary-900 dark:text-surface-0 font-semibold leading-tight"
                >OMS <small class="text-xs">ORGANIZATION MANAGEMENT SYSTEM</small></span
              >
            </div>
            <div class="text-base text-surface-500 dark:text-surface-300 leading-normal">
              &copy; {{ year }} OMS, All rights reserved.
            </div>
          </div>
          <div class="flex gap-8">
            <!-- <a
              class="cursor-pointer text-surface-900 dark:text-surface-0 transition-colors duration-150 hover:text-surface-700 dark:hover:text-surface-300"
            >
              <i class="pi pi-linkedin text-xl! leading-normal!"></i>
            </a>
            <a
              class="cursor-pointer text-surface-900 dark:text-surface-0 transition-colors duration-150 hover:text-surface-700 dark:hover:text-surface-300"
            >
              <i class="pi pi-instagram text-xl! leading-normal!"></i>
            </a>
            <a
              class="cursor-pointer text-surface-900 dark:text-surface-0 transition-colors duration-150 hover:text-surface-700 dark:hover:text-surface-300"
            >
              <i class="pi pi-github text-xl! leading-normal!"></i>
            </a> -->
          </div>
        </div>
      </div>
    </footer>
  `,
})
export class AppFooter {
  year = new Date().getFullYear();
  constructor() {}
}
